import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { initializeFirestore } from '../utils/initializeFirestore';

export const AdminInitializePage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  React.useEffect(() => {
    if (user?.role !== 'admin') {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  const handleInitialize = async () => {
    try {
      setLoading(true);
      setError(null);
      setSuccess(null);

      await initializeFirestore();
      setSuccess(
        'Firestore initialized successfully! Collections created with sample data.'
      );
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '40px 20px' }}>
      <h1>Initialize Firestore Database</h1>

      <div
        style={{
          background: '#fef3c7',
          border: '1px solid #f59e0b',
          padding: '16px',
          borderRadius: '8px',
          marginBottom: '24px',
        }}
      >
        <h3 style={{ margin: '0 0 8px 0' }}>⚠️ Setup Required</h3>
        <p style={{ margin: 0 }}>
          Your Firestore database is currently empty. Click the button below to
          create all necessary collections and add sample data to get started.
        </p>
      </div>

      {error && (
        <div
          style={{
            padding: '12px 16px',
            background: '#fee2e2',
            color: '#c33',
            marginBottom: '20px',
            borderRadius: '6px',
          }}
        >
          Error: {error}
        </div>
      )}

      {success && (
        <div
          style={{
            padding: '12px 16px',
            background: '#dcfce7',
            color: '#166534',
            marginBottom: '20px',
            borderRadius: '6px',
          }}
        >
          ✅ {success}
        </div>
      )}

      <div
        style={{
          background: 'white',
          padding: '24px',
          borderRadius: '8px',
          border: '1px solid #e5e7eb',
          marginBottom: '24px',
        }}
      >
        <h3 style={{ marginTop: 0 }}>What will be created:</h3>
        <ul style={{ color: '#6b7280', lineHeight: '1.8' }}>
          <li>5 Material Categories (Vinyl, Acrylic, Wood, Metal, Glass)</li>
          <li>10 Sample Materials with pricing</li>
          <li>5 Processes (CNC, Laminating, Printing, etc.)</li>
          <li>4 Labor Rates (Standard, Premium, Installation, Design)</li>
          <li>5 Vinyl Types (Cast, Calendered, Chrome, etc.)</li>
          <li>Company Settings (branding, colors, email)</li>
        </ul>
      </div>

      <button
        onClick={handleInitialize}
        disabled={loading}
        style={{
          width: '100%',
          padding: '14px 20px',
          background: loading ? '#ccc' : 'var(--primary-button)',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: loading ? 'not-allowed' : 'pointer',
          fontWeight: '600',
          fontSize: '16px',
        }}
      >
        {loading ? 'Initializing...' : 'Initialize Firestore Database'}
      </button>

      <button
        onClick={() => navigate('/dashboard')}
        style={{
          width: '100%',
          marginTop: '12px',
          padding: '14px 20px',
          background: '#f3f4f6',
          border: '1px solid #d1d5db',
          borderRadius: '8px',
          cursor: 'pointer',
          fontWeight: '600',
          fontSize: '16px',
        }}
      >
        Back to Dashboard
      </button>
    </div>
  );
};
